<template>
  <div id="task">
    <h2>タスク</h2>
    <div>
      <!-- inputに入力した値を、v-modelでnewTodoNameに即座に反映させる -->
      <input type="text" v-model="newTodoName">
      <!-- クリックしたら、createTodo()関数を呼び出す -->
      <button type="submit" v-on:click="createTodo()">タスク作成</button>
    </div>

    <ul>
      <li><button type="submit" v-on:click="showTodoType = 'all'">全て</button></li>
      <li><button  type="submit" v-on:click="showTodoType = 'active'">未完了タスク一覧</button></li>
      <li><button  type="submit" v-on:click="showTodoType = 'complete'">完了タスク一覧</button></li>
    </ul>

    <!-- todoの一覧表示 -->
    <ul v-for="(todo,key) in filteredTodos" :key="todo.id">
      <li><input class="toggle" type="checkbox" v-model="todo.isComplete" v-on:click="updateIsCompleteTodo(todo,key)">{{ todo.name}}</li>
      <button type="submit" v-on:click="deleteTodo(key)">削除</button>
    </ul>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name:"Task",
  data(){
    return{
      database: null,
      todosRef: null,
      newTodoName: "",
      showTodoType: "all",
      todos: []
    };
  },
  created: function(){
    this.database = firebase.database();
    // uidって何?user.idの略?
    // ログインしたユーザのユーザidを取得
    this.uid = firebase.auth().currentUser.uid;
    this.todosRef = this.database.ref("todos/" + this.uid);    
    this.todosRef.on("value", (snapshot)=>{
      this.todos = snapshot.val();
    });
  },
  computed: {
    filteredTodos: function(){
      if (this.showTodoType == "all"){
        return this.todos;
      } else {
        var showIsComplete = false;
        if(this.showTodoType == "complete"){
          showIsComplete = true;
        }
        var filterTodos = {};

        // each文って使えないの?
        for (var key in this.todos){ //keyはfirebaseにおける識別キー
          var todo = this.todos[key];
          if(todo.isComplete == showIsComplete){
            filterTodos[key] = todo;
          }
        }
        return filterTodos;

      }
    }
  },
  methods: {
    createTodo: function(){
      if(this.newTodoName == ""){
        return;
      }
      this.todosRef.push({
        // NoSQLなのでここで追加するカラムを設定する
        name: this.newTodoName,
        isComplete: false,
      });
      this.newTodoName = "";
    },

    updateIsCompleteTodo: function(todo, key){
      todo.isComplete =!todo.isComplete;
      var updates = {};
      updates[key] = todo;
      this.todosRef.update(updates)
    },

    deleteTodo: function(key){
      this.todosRef.child(key).remove();
    }
  }
}
</script>

<style>
</style>